import { isElectron } from '@/utils/electron';

/**
 * 公共模块
 */
export default {
  meta: { localeModules: [] },
  path: '/common',
  children: [
    // PDF预览
    {
      path: 'pdf-preview',
      name: 'pdfPreview',
      component: () => import('@/pages/common/pdfPreview'),
      meta: {
        name: 'routers.common_preview',
        componentName: 'PdfPreviewIndex',
        electronSingle: true,
        parent: '/question/list',
        hiddenNav: true,
        hideBreadcrumb: isElectron
      }
    },
    // PDF预览
    {
      path: 'questionnaire',
      name: 'questionnaire',
      component: () => import('@/pages/common/questionnaire'),
      meta: {
        name: 'routers.common_questionnaire',
        componentName: 'Questionnaire',
        electronSingle: true,
        parent: '/question/list',
        hiddenNav: true,
        hideBreadcrumb: isElectron
      }
    },
    // 路演详情
    {
      path: 'roadshow-detail',
      name: 'commonRoadshowDetail',
      component: () => import('@/pages/common/roadshowDetailEmpty'),
      meta: {
        name: 'routers.common_roadshow_detail',
        componentName: 'CommonRoadshowDetailIndex',
        electronSingle: true,
        parent: '/roadshow/list',
        // 其他父级页面
        otherParent: [
          '/scheduleManage/list',
          '/globalSearch/index',
          '/find/list',
          '/manage/profile',
          '/find/self-selected'
        ],
        hiddenNav: true,
        hideBreadcrumb: isElectron
      }
    },
    // 腾讯会议相关
    {
      path: 'tencent-meeting',
      name: 'tencentMeeting',
      component: () => import('@/pages/common/tencentMeeting'),
      meta: {
        name: 'routers.common_tencent_meeting',
        componentName: 'TencentPreviewIndex',
        electronSingle: true,
        parent: '/scheduleManage/list',
        hiddenNav: true,
        hideBreadcrumb: isElectron,
        otherParent: [
          '/scheduleManage/list',
          '/globalSearch/index',
          '/find/list',
          '/manage/profile',
          '/find/self-selected'
        ]
      }
    },
    // SpreadJS V19 临时预览
    {
      path: 'spreadjs-demo',
      name: 'spreadjsDemo',
      component: () => import('@/pages/common/spreadjsDemo'),
      meta: {
        name: 'SpreadJS V19 临时预览',
        componentName: 'SpreadjsDemo',
        requireAuth: false,
        hiddenNav: true,
        hideBreadcrumb: true
      }
    }
  ]
};
